<template>
  <div class="container">
    <div class="content">
      <div class="poster-box">
        <div class="content-poster" v-show="!showPoster">
          <van-image class="avatar" width="10vw" height="10vw" round :src="avatar"></van-image>
          <img class="test3" :src="newFile" alt="考生照片"  v-if="shownewFile">
          <img class="test1" id="img" v-show="!showPoster" :src="posterbackground" alt="海报背景">
          <div class="title">{{nickName}}</div>
          
        </div>
        <div class="content-poster" v-show="showPoster" >
          <img class="test2" :src="posterSrc" alt="合成海报">
        </div>
      </div>

      <div class="btn-div">
        <van-uploader ref="input" :before-read="beforeRead">
          <div
            class="input-btn btn button glass"
          >
            {{shownewFile? '重新上传' : '上传照片'}}
          </div> 
        </van-uploader>
        <van-button
          color="#1EA6FC"
          plain
          round
          class="bottom-btn"
          to="/submit"
          >更换背景
        </van-button>
        <van-button
          color="#1EA6FC"
          plain
          round
          :class="shownewFile? 'bottom-btn ech-shake' : 'bottom-btn'"
          @click="onDrawPoster()"
          >生成海报
        </van-button>
        <div style="padding:0 15vw;width: 100%;color: #444;font-size: 12px;margin-top: 10px;font-weight: 500;">用户上传图片时必须遵守相关法律法规</div>
        <div style="padding:0 15vw;width: 100%;color: #444;font-size: 12px;margin: 3px 0 30px;font-weight: 500;">否则一切法律后果自行承担</div>
      </div> 
      
    </div>
  </div>
  <!-- <CommentForm v-model:show="showform" @submit="onCommentSubmit"  /> -->
  <CropperPopup v-model:visible="visible" :file="fileRef" @submit="onCropSubmit" />
</template>

<script>
import CropperPopup from "@/components/Cropper";
import {
  Button,
  Grid,
  GridItem,
  Image as VanImage,
  ImagePreview,
  Empty,
  Uploader,
  Toast,
} from "vant";
import { useStore } from "vuex";
import {  ref, computed, onMounted } from "vue";
// import CommentForm from "@/components/CommentForm.vue";
import { useRoute } from "vue-router";
import { drawPoster } from "@/utils/beforUploadFn.js";
import { useRouter } from "vue-router";

export default {
  name: "Detail",
  components: {
    [VanImage.name]: VanImage,
    [ImagePreview.Component.name]: ImagePreview.Component,
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    [Button.name]: Button,
    // CommentForm,
    [Empty.name]: Empty,
    [Uploader.name]: Uploader,
    CropperPopup,
  },

  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const visible = ref(false)
    const fileRef = ref()
    const newFile = ref()
    const shownewFile = ref(false)
    const showPoster = ref(false)
    const posterSrc = ref("")
    const posterbackground = ref("")
     if (route.params.url) {
       posterbackground.value = route.params.url 
     }
     else router.push("/")

    const onCropSubmit = (file) => {
      newFile.value = file.content;
      shownewFile.value = true;
      showPoster.value = false;
      store.state.cropImage = file.content;
    }

    onMounted (() => {
      store.dispatch("getOrderNum");
      setTimeout(() => {
        let imgHeight = document.getElementById('img').offsetHeight;
        let btn = document.getElementsByClassName('btn-div')[0];
        let content = document.getElementsByClassName('content')[0];
        content.style.height = imgHeight + 'px';
        btn.style.top = imgHeight + 'px';
      }, 300);
    }) 

    const showform = ref(false);
    const selectedContentId = ref(0);
    const showComment = () => {
      showform.value = true;
    };

    const onCommentSubmit = () => {
      showform.value = false;
    }

    const beforeRead = (file) =>
      // new Promise((resolve, reject) => {
      {
        if (!/image\/[a-zA-z]+/.test(file.type)) {
          Toast('请上传正确格式的图片');
          return;
        } else {
          if (!file || !window.FileReader) return;
          const toast = Toast.loading({
            message: '加载中...',
            forbidClick: false,
          });
          const reader = new FileReader();
          reader.onload = (event) => {
            file.content = event.target.result;
            fileRef.value = file;
            visible.value = true;
						toast.clear();
          };
          reader.readAsDataURL(file);
        }
      }
      // });

    const onDrawPoster = () => {
      if (!shownewFile.value || !store.state.cropImage) {
        Toast("请上传照片");
        return;
      }
      let w;
      let h;
      let imgArgs;
      const image = store.state.cropImage;
      const text = store.state.orderNum;
      const posterbg = route.params.url;
      const nickName = store.state.nickName;
      const avatar = store.state.avatar;
      let cropimage = new Image();
      cropimage.src = image;
      cropimage.onload = function () {
        w = cropimage.naturalWidth;
        h = cropimage.naturalHeight;
        console.log(w, h);
        //  sx, sy, sw, sh, dx, dy, dw, dh
        imgArgs = {
          sx: 0,
          sy: 0,
          sw: w,
          sh: h,
          dx: 101.25,
          dy: 742.5,
          dw: 904.5,
          dh: 904.5,
          // dx: 46.875,
          // dy: 468.75,
          // dw: 656.25,
          // dh: 637.5,
        }
        drawPoster(image, imgArgs, text, posterbg, nickName, avatar).then(res => {
          
          console.log("合成成功", res);
          store.state.poster = res;
          posterSrc.value = res;
          showPoster.value = true;
          router.push("/postermerge");
        })
      }
    }

    return {
      detail: computed(() => store.state.detail),
      detailCategory: computed(() => store.state.detailCategory),
      showComment,
      showform,
      selectedContentId,
      covers: computed(() => store.state.covers),
      beforeRead,
      visible,
      fileRef,
      onCropSubmit,
      onCommentSubmit,
      newFile,
      shownewFile,
      commentform: computed(() => store.state.commentform),
      onDrawPoster,
      showPoster,
      posterSrc,
      posterbackground,
      avatar: computed(() => store.state.avatar),
      nickName: computed(() => store.state.nickName),
      fullNickName: computed(() => store.state.fullNickName),
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  position: relative;
  background: url("../assets/img/detail_background.png") no-repeat ;
  background-size: cover;
  padding-top: 4vw;
  padding-bottom: 20px;
  box-sizing: border-box;
  padding: 20px 0px;
}
.content {
  width: 100%;
  position: relative;
  min-height: 80vh;
  min-height: 100vh;
  img {
    width: 100%;
    height: auto;
    box-shadow: 0.5px 0.8px 5px white;
  }
}
.poster-box {
  width: 80%;
  height: auto;
  margin: 0 auto;
  position: relative;
}
.content-poster {
  position: relative;
  .test1 {
    position: absolute;
    top: 0;
    left: 0;
  }
  .test3 {
    position: absolute;
    top: 55vw;
    left: 7.5vw;
    width: 67vw;
    height: 67vw;
  }
  .avatar{
    position: absolute;
    top: 44vw;
    left: 7.4vw;
    width: 10vw;
    height: 10vw;
  }
  .title{
    position: absolute;
    top: 48.7vw;
    left: 16vw;
    width: 30vw;
    height: 7vw;
    color: #EF662A;
  }
}
.content-file {
  z-index: 0;
  width: 100%;
}
.comment-value {
  position: absolute;
  top: 130vw;
  left: 6vw;
  text-align: left;
  font-size: 3.6vw;
  .comment {
    color: #d64747;
    font-size: 3.8vw;
  }
  .username {
    margin-left: 140px;
    margin-top: 4px;
  }
}
.btn-div {
  margin: 0px auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  position: absolute;
  background: #d1f8ff;
  top: 110vh;
  padding-bottom: 20px;
}
.bottom-btn {
  width: 36vw;
  height: 32px;
  text-align: center;
  margin: 6vw 1vw 2vw 1vw;
  font-size: 3.8vw;
  box-shadow: 0.5px 0.8px 5px white;
}

.input-btn {
  background: linear-gradient(to right, #47a7f9, #73b5ed);
  background: #1EA6FC;
  box-shadow: 0.5px 0.8px 5px white;
  width: 70vw;
  height: 34px;
  line-height: 34px;
  font-size: 3.8vw;
  text-align: center;
  color: #ffffff;
  border-radius: 22px;
  margin-top: 10px;
}
.input {
  visibility: hidden;
  width: 120px;
}

</style>
